import { render } from "./PayrollView.vue?vue&type=template&id=3b5db6b2"
import script from "./PayrollView.vue?vue&type=script&lang=js"
export * from "./PayrollView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__